var exports = {
  "F": "successIcon__qh1XR6",
  "x": "successText__eEwuwz",
};

module.exports = exports;
